<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NBA Statistics</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019" selected>2019</option>
                                <option value="2020">2020</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
								<option value="PRE">PRE - Pre-season</option>
                                <option value="REG" selected>REG - Regular season</option>
                                <option value="PST">PST - Past season</option>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Standings</td>
							<td>
                                <a :href="getStandingsEndpoint(true)" target="_blank">{{ getStandingsEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>Rankings</td>
							<td>
                                <a :href="getRankingsEndpoint(true)" target="_blank">{{ getRankingsEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>Weekly League Leaders </td>
							<td>
                                <a :href="getWeeklyLeagueLeadersEndpoint(true)" target="_blank">{{ getWeeklyLeagueLeadersEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>League Hierarchy </td>
							<td>
                                <a :href="getLeagueHierarchyEndpoint(true)" target="_blank">{{ getLeagueHierarchyEndpoint(true) }}</a>
                            </td>
						</tr>
					</table>
				</div>
				
			</div>
		</div>

        <div>
            <div id="accordion">
                <div class="card" v-if="standings">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#standings" aria-expanded="true" aria-controls="collapseOne">
							Standings
							</button>
						</h5>
					</div>

					<div id="standings" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="conference in standings.conferences">
                                <h3>Conference {{ conference.name }}</h3>

                                <div v-for="division in conference.divisions">

                                    <h4>Division {{division.name}} - id: {{division.id}}</h4>

                                    <table class="table">
                                        <tr>
                                            <th>name</th>
                                            <th>wins</th>
                                            <th>losses</th>
                                            <th>win_pct</th>
                                            <th>points_for</th>
                                            <th>points_against</th>
                                            <th>point_diff</th>
                                            <th>games_behind</th>
                                            <th>streak</th>
                                            <th>records</th>
                                        </tr>
                                        <tr v-for="team in division.teams">
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>{{ team.wins }}</td>
                                            <td>{{ team.losses }}</td>
                                            <td>{{ team.win_pct }}</td>
                                            <td>{{ team.points_for }}</td>
                                            <td>{{ team.points_against }}</td>
                                            <td>{{ team.point_diff }}</td>
                                            <td v-if="team.games_behind">
                                                league: {{ team.games_behind.league }}<br>
                                                conference: {{ team.games_behind.conference }}<br>
                                                division: {{ team.games_behind.division }}<br>
                                            </td>
                                            <td v-if="team.streak">
                                                kind: {{ team.streak.kind }}<br>
                                                length: {{ team.streak.length }}<br>
                                            </td>
                                            <td>
                                                <div v-for="record in team.records" style="border-bottom:1px solid #ccc;">
                                                    record_type: {{ record.record_type }}<br>
                                                    wins: {{ record.wins }}<br>
                                                    losses: {{ record.losses }}<br>
                                                    win_pct: {{ record.win_pct }}<br>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="rankings != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#rankings" aria-expanded="true" aria-controls="collapseOne">
							Rankings
							</button>
						</h5>
					</div>

					<div id="rankings" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="conference in rankings.conferences">
                                <h3>Conference {{ conference.name }}</h3>

                                <div v-for="division in conference.divisions">

                                    <h4>Division {{division.name}} - id: {{division.id}}</h4>

                                    <table class="table">
                                        <tr>
                                            <th>team</th>
                                            <th>conference</th>
                                            <th>division</th>
                                            <th>clinched</th>
                                        </tr>
                                        <tr v-for="team in division.teams" v-if="team.rank">
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>{{ team.rank.conference }}</td>
                                            <td>{{ team.rank.division }}</td>
                                            <td>{{ team.rank.clinched }}</td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="weekly_league_leaders">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#weekly-league-leaders" aria-expanded="true" aria-controls="collapseOne">
							League Leaders 
							</button>
						</h5>
					</div>

					<div id="weekly-league-leaders" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="category in weekly_league_leaders.categories">
                                <h3>{{ category.name }} {{ category.type }}</h3>

                                <table class="table">
                                    <tr>
                                        <th>rank</th>
                                        <th>tied</th>
                                        <th>score</th>
                                        <th>player</th>
                                        <th>teams</th>
                                        <th>total</th>
                                        <th>average</th>
                                    </tr>
                                    <tr v-for="rank in category.ranks">
                                        <td>{{ rank.rank }}</td>
                                        <td>{{ rank.tied }}</td>
                                        <td>{{ rank.score }}</td>
                                        <td>{{ rank.player.full_name }}</td>
                                        <td>
                                            <div v-for="team in rank.teams">
                                                {{ team.market }} {{ team.name }}<br>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-for="total, key in rank.total">
                                                {{ key }}: {{ total }}
                                            </div>
                                        </td>
                                        <td>
                                            <div v-for="total, key in rank.average">
                                                {{ key }}: {{ total }}
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="league_hierarchy">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#league_hierarchy" aria-expanded="true" aria-controls="collapseOne">
							League Hierarchy
							</button>
						</h5>
					</div>

					<div id="league_hierarchy" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="conference in league_hierarchy.conferences">
                                <h3>Conference {{ conference.name }}</h3>

                                <div v-for="division in conference.divisions">

                                    <h4>Division {{division.name}} - id: {{division.id}}</h4>

                                    <table class="table">
                                        <tr>
                                            <th>name</th>
                                            <th>market</th>
                                            <th>alias</th>
                                            <th>sr_id</th>
                                            <th>id</th>
                                        </tr>
                                        <tr v-for="team in division.teams">
                                            <td>{{ team.name }}</td>
                                            <td>{{ team.market }}</td>
                                            <td>{{ team.alias }}</td>
                                            <td>{{ team.sr_id }}</td>
                                            <td>{{ team.id }}</td>
                                            
                                        </tr>
                                    </table>

                                </div>
                            </div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'app',
    components: {

	},
    created: function() {

        this.loadStandings();
        this.loadRankings();
        this.loadWeeklyLeagueLeaders();
        this.loadLeagueHierarchy();
    
    },
    data: function() {
        return {            
            apiKey: 'c35guurt2ystkshn7szzxhp8',
            year: 2019,
            season: "REG",
            week: 1,
            standings: [],
            rankings: [],
            standings_fields: [
                'overall',
                'in_conference',
                'non_conference',
                'in_division',
                'home',
                'away',
                'overtime',
                'grass',
                'turf',
                'scored_first',
                'decided_by_7_points',
                'leading_at_half',
                'last_5',
                'points',
                'touchdowns',
                'streak',
            ],
            league_hierarchy: [],
            weekly_league_leaders: [],
            statistics_types: [
                {
                    name: "passing",
                    fields: [
                        "att",
                        "cmp",
                        "yds",
                        "lg",
                        "sk",
                        "sk_yds",
                        "td",
                        "int",
                        "int_td",
                        "fd",
                        "sfty",
                        "rz_att",
                        "rating",
                        "avg",
                        "cmp_pct",
                        "cmp_avg",
                        "td_pct",
                        "int_pct",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "rushing",
                    fields: [
                        "att",
                        "yds",
                        "avg",
                        "lg",
                        "td",
                        "fd",
                        "fd_pct",
                        "sfty",
                        "rz_att",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "receiving",
                    fields: [
                        "tar",
                        "rec",
                        "yds",
                        "yac",
                        "fd",
                        "avg",
                        "td",
                        "lg",
                        "rz_tar",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "field_goal",
                    fields: [
                        "att",
                        "made",
                        "pct",
                        "lg",
                        "att_19",
                        "made_19",
                        "att_29",
                        "made_29",
                        "att_39",
                        "made_39",
                        "att_49",
                        "made_49",
                        "att_50",
                        "made_50",
                    ]
                },
                {
                    name: "extra_point",
                    fields: [
                        "att",
                        "made",
                        "pct",
                        "blk",
                    ]
                },
            ]
        }
    }, 
    methods: {
        getStandingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/standings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getRankingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/rankings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getWeeklyLeagueLeadersEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/seasons/${this.year}/${this.season}/leaders.json?api_key=${this.apiKey}`;


            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getLeagueHierarchyEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nba/production/v5/en/league/hierarchy.json?api_key=${this.apiKey}`;


            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        

        loadStandings: function() {

            // get full list of tournaments
            axios.get(this.getStandingsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('standings', response.data);

                this.standings = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadRankings: function() {

            // get full list of tournaments
            axios.get(this.getRankingsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('rankings', response.data);

                this.rankings = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadWeeklyLeagueLeaders: function() {

            // get full list of tournaments
            axios.get(this.getWeeklyLeagueLeadersEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('weekly_league_leaders', response.data);

                this.weekly_league_leaders = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadLeagueHierarchy: function() {

            // get full list of tournaments
            axios.get(this.getLeagueHierarchyEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('league_hierarchy', response.data);

                this.league_hierarchy = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadWeeklyLeagueLeaders();
            this.loadLeagueHierarchy();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadWeeklyLeagueLeaders();
            this.loadLeagueHierarchy();
        },

        selectWeek: function(event) {

            this.week = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadWeeklyLeagueLeaders();
            this.loadLeagueHierarchy();
        }
    },
}
</script>